import styled from "styled-components";
import colors from "../../config/colors";

export const ModalContainer = styled.div`
    width=${(props) => props.isWidth && "300px"}
    max-width=${(props) => props.isWidth && "300px"}
    
`;

export const ModalBackground = styled.div`
  position: fixed;
  top: ${(props) => (props.isMain ? "-49px" : props.isAddCreate ? "0" : "0")};
  left: 0;
  width: 100vw;
  height: ${(props) => (props.isHeighCalc ? "calc(100vh - 67px)" : "100vh")};
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(10px);
  z-index: ${(props) => (props.isMain ? "1000" : "100")};
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: ${(props) =>
    props.isMain || props.isCreate || props.isAddCreate ? "0" : "20px"};
`;
export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${colors.background};
  padding: ${(props) =>
    props.isMeeting ? "30px 40px" : props.noPadding ? "0" : "20px"};
  padding-bottom: ${(props) => (props.paddingBottom ? "0" : "25px")};
  width: ${(props) => props.fixedWidth && props.fixedWidth};
  min-width: ${(props) => (props.minWidth ? props.minWidth : "30vw")};
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : "100%")};
  height: ${(props) =>
    props.isHeight ? props.isHeight : props.isMeeting ? "100%" : ""};
  min-height: ${(props) => props.isMeeting && "500px"};
  max-height: ${(props) => props.isMeeting && "fit-content"};
  border-radius: 10px;
  position: relative;
  overflow-y: auto;
  @media (max-width: 992px) {
    width: ${(props) => props.fixedWidth && "700px"};
  }
  &.layout-styles {
    padding: 0;

    .actionbtns3 {
      div {
        font-family: "Nunito Sans";
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        box-shadow: none;
      }
      div:nth-child(1) {
        margin-right: ${(props) => (props.isButtonCenter ? "" : "auto")};
        @media (max-width: 767px) {
          margin: 0;
        }
      }
    }
  }
  @media (max-width: 992px) {
    width: ${(props) => (props.setModalrespon ? "80%" : " initial !important")};
  }

  @media (max-width: 767px) {
    align-self: self-start;
    // max-height: 76vh;
    width: ${(props) => props.fixedWidth && "auto"};
    width: ${(props) =>
      props.setModalrespon ? "calc(100vw - 70px)" : " initial !important"};
  }
`;

export const ModalTitle = styled.div`
  font-size: ${(props) => (props.isMeeting ? "22px" : "20px")};
  font-weight: bold;
  color: ${(props) => (props.isMeeting ? "#222121" : "#302F2F")};
  font-family: ${(props) => props.isMeeting && "Nunito Sans"};
  margin-bottom: ${(props) => (props.isMeeting ? "5px" : "20px")};
  position: relative;
  ${(props) => (props.hideBorder ? "" : `border-bottom: 1px solid #ededed;`)}
  padding-bottom: 13px;
  padding-right: 45px;
  svg {
  }
  span {
    font-family: ${(props) => (props.isModalStyle ? "Nunito Sans" : "Inter")};
    @media (max-width: 767px) {
      width: 98%;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      overflow: hidden;
    }
  }
`;

export const ModalActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${(props) => (props.isButtonCenter ? "center" : "flex-end")};
  margin: ${(props) =>
    props.isMain || props.isCreate || props.isAddCreate
      ? "30px 0px 0px"
      : "45px 20px 20px"};
  gap: 12px;
  @media (max-width: 480px) {
    justify-content: center;
    flex-wrap: wrap;
    gap: 10px;
  }
  &.custom-modal {
    display: flex;
    align-items: center;
    justify-content:${(props) =>
      props.isButtonCenter || props.isModalStyle ? "center" : "flex-end"};
    margin: ${(props) =>
      props.isAddParticipants ? "25px 0 0" : "45px 20px 20px"} ;
    gap: 12px;
        @media (max-width:480px){
            justify-content: center; 
            flex-wrap: wrap;
            gap: 10px;
        }
        &.custom-modal {
            display:flex;
            justify-content:center;
            margin:20px auto 30px auto;
        }
`;

export const IconWrapper = styled.div`
  position: absolute;
  top: ${(props) => (props.setIconStyle ? props.setIconStyle : "0px")};
  right: ${(props) => (props.setIconStyle ? props.setIconStyle : "0px")};
  cursor: pointer;
  z-index: 10;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 7px 6px;
  box-sizing: border-box;
  background: rgba(219, 219, 219, 0.3);
`;
